export default __webpack_public_path__ + "static/media/pic2.83f3d736.jpg";